import PropTypes from 'prop-types'
import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import classes from './Avatar.module.scss'

export class AvatarLoader extends React.PureComponent {
  static propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
  }

  static defaultProps = {
    isActive: true,
    size: 40,
  }

  render () {
    const {
      size,
      className,

      ...props
    } = this.props

    let compClassName = classes.avatar
    if (className) compClassName += ' ' + className

    const avatarStyle = {
      width: size + 'px',
      height: size + 'px',
      lineHeight: size + 'px',
      fontSize: Math.ceil((size / AvatarLoader.defaultProps.size) * 18),
      color: 'inherit'
    }

    return (
      <span
        {...props}
        className={compClassName}
        style={avatarStyle}
      >
        <KanBoIcon spin name='kanbo-16-loading' style={{ width: '100%' }} />
      </span>
    )
  }
}

export default AvatarLoader
